module.exports = __webpack_public_path__ + "img/logo.a778c34a.png";